<template>
  <div>
    <template v-if="totalProjection > 0">
      <div class="fs-8 fw-bolder text-secondary font-variant-numeric-tabular">
        {{ formattedTotalProjection }} MWh
      </div>
      <div class="fs-9 fw-bold text-secondary text-uppercase">
        {{ $t("tradingCenter.overview.projectedProduction.title") }}
      </div>
    </template>
    <template v-else>
      <div class="p-3 border rounded bg-light text-center text-muted">
        {{ $t("tradingCenter.overview.projectedProduction.noData") }}
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { formatNumberWithSpaces } from "@/composables/formatUtils";
import { ProjectionsByTechnology } from "@/types/projections";
import { calculateTotalProjection } from "@/utils/projections";
import { computed } from "vue";

export interface ProjectedProductionOverviewProps {
  projections: ProjectionsByTechnology;
}

const props = defineProps<ProjectedProductionOverviewProps>();

const totalProjection = computed(() => {
  return calculateTotalProjection(props.projections);
});

const formattedTotalProjection = computed(() => {
  return formatNumberWithSpaces(Math.round(totalProjection.value));
});
</script>

<style scoped lang="scss">
.font-variant-numeric-tabular {
  font-variant-numeric: tabular-nums;
  font-feature-settings: "tnum";
}
</style>
